import {
  CREATE_SUBTOPIC_DONE,
  CREATE_SUBTOPIC_ERROR,
  GET_SUBTOPIC_DONE,
  GET_SUBTOPIC_ERROR,
} from "../../actions/subtopics";

const initState = {
  groupSubtopicData: [],
};

export const subtopicsReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_SUBTOPIC_DONE:
      return {
        ...state,
        groupSubtopicData: action?.payload || [],
      };
    case GET_SUBTOPIC_ERROR:
      return { ...state };
    case CREATE_SUBTOPIC_DONE:
      return { ...state };
    case CREATE_SUBTOPIC_ERROR:
      return { ...state };
    default:
      return state;
  }
};
